// src/context/ThemeContext.js
import React, { useState, useMemo, createContext, useContext } from 'react';
import { createTheme } from '@mui/material/styles';

const ThemeContext = createContext();

export function useThemeContext() {
    return useContext(ThemeContext);
}

export function AppThemeProvider({ children }) {
    const [mode, setMode] = useState('light');

    const themeMethods = useMemo(
        () => ({
            toggleTheme: () => {
                setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
            },
        }),
        [],
    );

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                },
            }),
        [mode],
    );

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme: themeMethods.toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}